export const GA_EVENT_NAME_LIMIT = 40; // This is set by Google
export const GA_EVENT_PREFIX = "admin_center";
